import { render } from "./NamespaceAdd.vue?vue&type=template&id=acd6154e"
import script from "./NamespaceAdd.vue?vue&type=script&lang=js"
export * from "./NamespaceAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__